<template>
  <div class="step1">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0px"
      class="demo-ruleForm"
    >
      <el-form-item prop="phone">
        <el-input
          prefix-icon="iconfont iconqita-1shouji_1"
          type="text"
          v-model="ruleForm.phone"
          autocomplete="off"
          placeholder="请输入手机号"
          :disabled="phoneInp"
        ></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input
          prefix-icon="iconfont iconqita-2yanzhengma_1"
          type="text"
          v-model="ruleForm.code"
          autocomplete="off"
          placeholder="请输入手机验证码"
          style="width:285px;"
        ></el-input>
        <el-button
          :disabled="showGetCode"
          @click="onGetCode"
          class="defaultButtonClass"
          ref="codeButton"
          id="codeRef"
        >{{ this.codeText }}</el-button>
      </el-form-item>
      <el-form-item prop="name">
        <el-input
          v-model="ruleForm.name"
          autocomplete="off"
          type="text"
          placeholder="请输入姓名"
          prefix-icon="iconfont iconqita-3yonghu_1"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="ruleForm.password"
          show-password
          placeholder="大小写字母、数字或特殊字符组合"
          prefix-icon="iconfont iconqita-5mima_5"
        ></el-input>
      </el-form-item>
      <el-form-item prop="confirmPwd">
        <el-input
          v-model="ruleForm.confirmPwd"
          type="password"
          show-password
          placeholder="再次确认密码"
          prefix-icon="iconfont iconqita-5mima_5"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import commonApi from 'api/common';
import registerApi from 'api/register/register';

export default {
  data() {
    /* 手机号验证 */
    var validatePhone = (rule, value, callback) => {
      if (value === '' || !value) {
        this.showGetCode = true;
        callback(new Error('请输入手机号'));
      } else if (!/^[0123456789]\d{10}$/.test(value)) {
        this.showGetCode = true;
        callback(new Error('请输入正确的手机号'));
      } else {
        commonApi
          .checkPhoneExist({
            phone: value
          })
          .then(res => {
            // 已存在
            if (res.data.data) {
              this.showGetCode = true;
              callback(new Error('该账号已存在，请重新输入'));
            } else {
              // 不存在，可注册
              this.showGetCode = false;
              callback();
            }
          });
      }
    };
    /* 姓名验证 */
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能为空'));
      } else if (!/^[\u4E00-\u9FA5]+$/.test(value)) {
        callback(new Error('只能是中文'));
      } else if (value.length > 10) {
        callback(new Error('最多输入10个汉字'));
      } else {
        callback();
      }
    };
    /* 密码验证 */
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('输入不能为空!'));
      } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,16}$/.test(value)) {
        callback(new Error('6~16位字母、数字或特殊字符组合'));
      } else {
        if (this.ruleForm.confirmPwd !== '') {
          this.$refs.ruleForm.validateField('confirmPwd');
        }
        callback();
      }
    };
    /* 确认密码验证 */
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('输入不能为空!'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('新密码两次输入不同，请重新输入!'));
      } else {
        callback();
      }
    };
    /* 手机验证码验证 */
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机验证码'));
      } else if (!/^[0123456789]\d{5}$/.test(value)) {
        callback(new Error('请输入正确的验证码'));
      } else {
        callback();
      }
    };
    return {
      /* 步骤一表单数据 */
      ruleForm: {
        phone: '',
        code: '',
        name: '',
        password: '',
        confirmPwd: ''
      },
      showGetCode: true,
      noInp: false,
      phoneInp: false,
      codeText: '获取验证码',
      countDown: 60,
      rules: {
        phone: [{ validator: validatePhone, trigger: 'change', required: true }],
        password: [{ validator: validatePass, trigger: 'blur', required: true }],
        name: [{ validator: checkName, trigger: 'blur', required: true }],
        confirmPwd: [{ validator: validateConfirmPwd, trigger: 'blur', required: true }],
        code: [{ validator: validateCode, trigger: 'blur', required: true }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return;
        }
        // 短信验证码验证
        commonApi
          .postCheckMessageCode({
            phone: this.ruleForm.phone,
            validateCode: this.ruleForm.code
          })
          .then(res => {
            // 验证不通过
            if (!res.data.data) {
              this.$message({
                message: '短信验证码验证失败，请检查后重新输入',
                type: 'error',
                duration: 4000
              });
            } else {
              // 验证成功
              this.$nextTick(() => {
                this.showGetCode = false;
                this.countDown = 5;
                this.codeText = '获取验证码';
              });
              this.$emit('goToStep1', 1);
              /* 验证通过清除缓存 */
              sessionStorage.clear();
              // 注入 vuex
              this.$store.commit('SET_NAME', this.ruleForm.name);
              this.$store.commit('SET_PHONE', this.ruleForm.phone);
              this.$store.commit('SET_PASSWORD', this.ruleForm.password);
            }
          });
      });
    },
    /* 倒计时 */
    countDownTime() {
      if (!this.countDown) {
        document.getElementById('codeRef').style.background = '#f56c6c';
        this.showGetCode = false;
        this.noInp = false;
        this.phoneInp = false;
        this.countDown = 60;
        this.codeText = '获取验证码';
        return;
      } else {
        this.showGetCode = true;
        this.codeText = '(' + this.countDown + 's' + ')';
        this.countDown--;
      }
      setTimeout(() => {
        this.countDownTime();
      }, 1000);
    },
    /* 获取验证码 */
    onGetCode() {
      this.noInp = true;
      this.phoneInp = true;
      this.countDownTime();
      /* 这里发送请求得到验证码 */
      commonApi
        .postSendMessage({
          phone: this.ruleForm.phone,
          templateCode: 'SMS_202805860'
        })
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: '短信验证码发送成功，请注意查收',
              type: 'success'
            });
          }
          // else {
          //   this.$message.error(res.data.message);
          // }
        });
    }
  },
  watch: {
    showGetCode: function (newVal, oldVal) {
      if (!newVal && !this.noInp) {
        document.getElementById('codeRef').style.background = '#f56c6c';
      } else {
        document.getElementById('codeRef').style.background = '#dcdfe7';
      }
    }
  },
  mounted() {
    sessionStorage.clear();
  }
};
</script>

<style lang="less" scoped>
.step1 {
  width: 600px;
  margin: 50px auto 0;
  /deep/.el-form-item {
    margin-bottom: 24px;
  }
  /deep/.el-input__inner::placeholder {
    color: #c0c4ce;
  }
  /deep/.el-input {
    width: 410px;
  }
  /deep/.el-button--primary {
    width: 410px;
    background: linear-gradient(90deg, #4189fd 0%, #409dff 100%);
    box-shadow: 0px 3px 6px rgba(64, 157, 255, 0.3);
    border-radius: 20px;
    margin-top: 56px;
  }
  /deep/.el-form-item__error {
    left: 95px;
  }
  /* 默认灰色按钮 */
  .defaultButtonClass {
    width: 115px;
    display: inline-block;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    background: #dcdfe7;
    color: #fff;
    height: 40px;
    border: 0;
    margin-left: 10px;
  }
  /* 红色按钮 */
  .greyButtonClass {
    width: 115px;
    display: inline-block;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    background: #f56c6c;
    color: #fff;
    height: 40px;
    border: 0;
    margin-left: 10px;
  }
  .greyButtonClass:hover {
    cursor: pointer;
  }
  /deep/.iconfont {
    font-size: 24px;
  }
}
</style>
